<script>
import MaterialAvatar from '@/components/exchange/material/MaterialAvatar.vue';
import UserAvatar from '@/components/UserAvatar.vue';
import BaseCheckbox from '@/components/BaseCheckbox.vue';
import EllipsisMenu from '@/components/EllipsisMenu.vue';
import MaterialBidTile from '@/components/exchange/material/MaterialBidTile.vue';
import MaterialBidForm from '@/components/exchange/material/MaterialBidForm.vue';
import utils from '@/utils/common';
import MaterialBidList from '@/components/exchange/material/MaterialBidList.vue';
import { units } from '@/utils/enum';
import FileTile from '@/components/FileTile.vue';
import MaterialStatus from '@/components/exchange/material/MaterialStatus.vue';

export default {
  name: 'MaterialRow',
  components: {
    MaterialStatus,
    FileTile,
    MaterialBidList,
    MaterialBidTile,
    MaterialBidForm,
    EllipsisMenu,
    BaseCheckbox,
    UserAvatar,
    MaterialAvatar,
  },
  props: {
    item: Object,
    checked: Boolean,
    categories: Array,
  },
  data() {
    return {
      expanded: false,
    };
  },
  computed: {
    menuItems() {
      return [
        { text: 'Редактировать', icon: 'edit', handler: () => { this.$emit('update'); } },
        { text: 'Удалить', icon: 'trash', handler: () => { this.$emit('delete'); } },
      ];
    },
    categoriesNames() {
      const categories = [];
      let next = this.item.category?.['@id'];

      do {
        const curr = this.categories.find(c => c['@id'] === next);
        if (!curr) break;
        categories.push(curr.name);
        next = curr.parent;
      } while (next);

      return categories.reverse();
    },
    deadlineAt() {
      return this.item?.mainBid?.deliveryDate ? utils.convertDateToString(new Date(this.item?.mainBid?.deliveryDate), 'short') : '-';
    },
    supplierName() { return this.item?.mainBid?.supplierManual?.name || '-'; },
    suppliersCntQty() { return utils.pluralWord(this.item.bids.length, 'поставщик', 'поставщика', 'поставщиков'); },
    size() { return this.item.mainBid?.size || '-'; },
    totalVolume() {
      if (!this.item.mainBid) return '-';
      const { volume, quantity, volumeUnit } = this.item.mainBid;
      if (!volume || !quantity || !volumeUnit) return '-';

      const total = volume * quantity;
      const unit = units.volume[volumeUnit];
      return `${total} ${unit}`;
    },
    totalPrice() {
      if (!this.item.mainBid) return '-';
      const { price, priceCurrency, quantity } = this.item.mainBid;
      if (!price || !priceCurrency || !quantity) return '-';

      const total = quantity * price;
      const unit = units.currency[priceCurrency];
      return `${total} ${unit}`;
    },
  },

};
</script>

<template lang="pug">
.material-row
  .main
    BaseCheckbox(:value="checked" @change="$emit('check', $event)")
    UserAvatar(:user="item")
    .name {{ item.name }}
    .category {{ categoriesNames[0] }}
      .subcategory(v-for="category in categoriesNames.slice(1)") {{ category }}
    .size {{ size }}
    .rooms {{ item.rooms.join(', ') }}
    .supplier(v-if="item.mainBid") {{ supplierName }}
      span(v-if="item.bids.length > 1") ({{ suppliersCntQty }})
    .no-supplier(v-else) Нет поставщиков
    div
      .qty {{ totalVolume }}
    div
      .sum {{ totalPrice }}
    .deadline {{ deadlineAt }}
    .status
      MaterialStatus(:editable="false" :status="item.status || 'new'")
    .file
      FileTile(v-if="item.file" sm :file="item.file")
      template(v-else) -
    EllipsisMenu(:items="menuItems")
    button.expand(:class="{ expanded }" @click="expanded = !expanded")
      Icon(name="angle-down" colored pointer)
  MaterialBidList(
    v-if="expanded"
    :items="item.bids"
    :mainBid="item.mainBid"
    @select="$emit('selectBid', $event)"
    @create="$emit('createBid', $event)"
    @update="$emit('updateBid', $event)"
    @delete="$emit('deleteBid', $event)"
  )
</template>

<style scoped lang="scss">
.material-row {
  background-color: #F8F9FC;
  border-radius: 6px;
  color: #1E3147;
}

.main {
  padding: 22px 40px 22px 20px;
  display: grid;
  //grid-template-columns: 22px 55px 1fr 100px 90px 170px 130px 80px 100px 120px 130px 120px 24px;
  //grid-template-columns: 22px 55px 15fr 12fr 9fr 17fr 13fr 8fr 10fr 12fr 13fr 12fr 24px;
  grid-template-columns: 22px 55px 15fr 12fr 9fr 17fr 13fr 8fr 10fr 12fr 13fr 12fr 24px;
  align-items: center;
  gap: 12px;
  position: relative;
}

.name {
  font-size: 13px;
  line-height: 20px;
}

.category {
  font-size: 13px;
}

.subcategory {
  font-size: 12px;
  color: #33A1FB;
}

.supplier {
  color: #1E3147;
  font-size: 16px;
  line-height: 24px;

  span {
    font-size: 12px;
    line-height: 18px;
    color: #33A1FB;
  }
}

.no-supplier {
  font-size: 16px;
  line-height: 19px;
  color: #92A0B0;
}

.size {
  font-size: 13px;
}

.rooms {
  font-size: 12px;
  flex-shrink: 2;
}

.supplier {
  font-size: 16px;

  span {
    display: block;
    font-size: 12px;
  }
}

.qty, .sum {
  font-size: 12px;
  line-height: 20px;
  color: #FFFFFF;
  padding: 0 10px;
  display: inline-flex;
  align-items: center;
}

.qty {
  background-color: #FFBB94;
}

.sum {
  background-color: #A1CCF4;
}

.deadline {
  font-size: 13px;
  color: #788CA1;
}

.file {
  min-width: 0;
}

.expand {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  width: 20px;
  background: #E0F0FF;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 0 6px 6px 0;

  svg {
    rotate: 90deg;
    color: #1E3147;
  }

  &.expanded {
    border-radius: 0 6px 0 0;

    svg {
      rotate: 0deg;
    }
  }
}
</style>
